import styled from "styled-components";
import { Colors, WEEK_INDEX } from "../../config/Constants";
import Button from "../Button";
import DatePickerInput from "../Datepicker";
const refreshIcon = require("../../assets/images/refresh.png");

interface Props {
  calendarDate: Date;
  today: Date;
  onBlockSlotSelect: any;
  onBlockDateSelect: any;
  onCalendarDateChange: any;
  outletInfo: any;
  onRefresh: any;
}

const SlotTabHeader = ({
  calendarDate,
  today,
  onBlockSlotSelect,
  onBlockDateSelect,
  onCalendarDateChange,
  outletInfo,
  onRefresh,
}: Props) => {
  const filterDates = (date: any) => {
    if (
      outletInfo?.bookingWeekDays &&
      outletInfo?.bookingWeekDays?.length > 0
    ) {
      let d = new Date(date);
      let day = d.getDay();
      let dayString = WEEK_INDEX[day];
      return outletInfo.bookingWeekDays.indexOf(dayString) >= 0;
    } else {
      return true;
    }
  };
  return (
    <StyledSlotTabHeader>
      <DatePickerInput
        //@ts-ignore
        outlined={false}
        width="10rem"
        value={calendarDate}
        // maxDate={today}
        onChange={(e) => onCalendarDateChange(e)}
        filterDate={(date: any) => filterDates(date)}
      />
      <ActionContainer>
        <Button
          label="Block Slot"
          variant="filled"
          width="10rem"
          color={Colors.red}
          onClick={onBlockSlotSelect}
        />
        <Button
          label="Block Date"
          variant="filled"
          width="10rem"
          color={Colors.red}
          onClick={onBlockDateSelect}
        />
        <Button
          variant="filled"
          color={Colors.red}
          onClick={onRefresh}
          labelIcon={refreshIcon}
        />
      </ActionContainer>
    </StyledSlotTabHeader>
  );
};

const ActionContainer = styled.div`
  display: flex;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    gap: 0.1rem;
  }
`;
const StyledSlotTabHeader = styled.div`
  margin: 1rem 0;
  display: flex;
  align-content: center;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 1rem;
    margin-top: 3rem;
  }
`;

export default SlotTabHeader;
